import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { WindowRef } from '@shared/services/window-ref/window-ref.service';
import { switchMap } from 'rxjs';

import { External } from '../../actions';
import { MinorContinue } from '../../actions/minor-transfer/minor-transfer.actions';
import { State } from '../../reducers/index';

@Injectable()
export class MinorEffects {
  constructor(
    private actions$: Actions,
    private globalStore$: Store<State>,
    private windowRef: WindowRef,
  ) {}

  minorWelcomeContinue$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MinorContinue),
        switchMap(() => {
          const welcomeUrl = this.windowRef.nativeWindow.location.href.includes('minor-transfer')
            ? '/minor-transfer/overview'
            : '/minor-welcome';
          const baseHref = this.windowRef.nativeWindow.location.href
            .split('?')[0]
            .slice(0, -welcomeUrl.length);
          const url = baseHref + '/secure/minor-transfer/transfer-from';
          return [External({ url: url })];
        }),
      ),
    { dispatch: true },
  );
}

export const effects: any[] = [MinorEffects];
